// // /////serach icon filter corrrectly but online,offline,oncall works only in the current page
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
  Form,
  ModalBody,
  Label,
  ModalFooter,
} from "reactstrap";
import { CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

import { Link } from "react-router-dom";
import {
  PlusSquare,
  Wifi,
  WifiOff,
  Target,
  PhoneCall,
  Video,
} from "react-feather"; // added PhoneCall
import axios from "axios";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import { ViewAgentTitle, AgentTitle, Href } from "../../../Utils/Constants";
import { Badges, H5, P, UL, LI, Image, Btn } from "../../../AbstractElements";
import { baseUrl, mediaUrl, uploadFile } from "../../../Utils/FileUpload";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import StarRatings from "react-star-ratings";
import { useForm, Controller } from "react-hook-form";
// ✅ Updated with "On Call" status tab
const projectListNavList = [
  { id: 1, icon: <Target />, text: "All" },
  { id: 2, icon: <Wifi />, text: "Online" },
  { id: 3, icon: <WifiOff />, text: "Offline" },
  { id: 4, icon: <PhoneCall />, text: "On Call" },
];
interface Agent {
  id: string;
  agent_name: string;
  email: string;
  address: string;
  phone: string;
  image: string;
  is_online: number;
  is_active: number;
  languages?: { language: string; icon: string }[];
  brands?: { brand_name: string; logo: string }[];
  is_deleted: number;
}

export default function ViewAgent() {
  const [activeTab, setActiveTab] = useState(1);
  const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
  const [disableAllDelete, setDisableAllDelete] = useState(false);
  const [filteredItems, setFilteredItems] = useState<Agent[]>([]);
  const [refresh, setRefresh] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
  const [disableAllEnable, setDisableAllEnable] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [filterText, setFilterText] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState<number>(6);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [status, setStatus] = useState<number | null>(null);
  const [showPayoutModal, setShowPayoutModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<any>(null);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const fetchData = async (
    page = 1,
    perPage = 6,
    searchText = "",
    status: number | null = null
  ) => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}agent/get_all`, {
        params: {
          page,
          per_page: perPage,
          search: searchText.trim() !== "" ? searchText : undefined,
          status: status,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log(response.data.data[0]);
      const data: Agent[] = response.data.data;
      // console.log(data);
      const paginationInfo = response.data;
      setFilteredItems(data);
      setTotalPages(paginationInfo.last_page); // Update the total pages
      setCurrentPage(paginationInfo.current_page); // Update the current page
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Debounce search term
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(filterText);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [filterText]);

  useEffect(() => {
    const newStatus =
      activeTab === 1 ? null : activeTab === 2 ? 1 : activeTab === 3 ? 0 : 2;
    setStatus(newStatus);
    fetchData(currentPage, perPage, debouncedSearchTerm, newStatus);
  }, [activeTab, currentPage, perPage, debouncedSearchTerm, refresh]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleAdd = () => {
    navigate("/add_agent");
  };

  const handlehistory = () => {
    navigate("/call_history");
  };

  const handleVideoHistory = () => {
    navigate("/video_call_history");
  };

  // ✅ Updated filter logic
  const getFilteredAgents = () => {
    let agents = filteredItems;

    // Apply tab filter
    switch (activeTab) {
      case 2:
        agents = agents.filter((item: any) => item.is_online === 1);
        break;
      case 3:
        agents = agents.filter((item: any) => item.is_online === 0);
        break;
      case 4:
        agents = agents.filter((item: any) => item.is_online === 2);
        break;
      default:
        break;
    }

    // Apply search filter
    if (filterText.trim() !== "") {
      const lowerSearch = filterText.toLowerCase();

      agents = agents.filter((item: Agent) => {
        const matchAgentName = item.agent_name
          ?.toLowerCase()
          .includes(lowerSearch);
        const matchEmail = item.email?.toLowerCase().includes(lowerSearch);
        const matchPhone = item.phone?.toLowerCase().includes(lowerSearch);
        const matchAddress = item.address?.toLowerCase().includes(lowerSearch);

        const matchLanguages = item.languages?.some((lang: any) =>
          lang.language.toLowerCase().includes(lowerSearch)
        );

        const matchBrands = item.brands?.some((brand: any) =>
          brand.brand_name.toLowerCase().includes(lowerSearch)
        );

        return (
          matchAgentName ||
          matchEmail ||
          matchPhone ||
          matchAddress ||
          matchLanguages ||
          matchBrands
        );
      });
    }

    return agents;
  };


  const handleEdit = (id: string) => {
    navigate("/edit_agent", { state: { id: id } });
  };

  const handleagenthistory = (id: string) => {
    navigate("/call_history", { state: { agent_id: id } });
  };

  const handleVideoCallHistory = (id: string) => {
    navigate("/video_call_history", { state: { agent_id: id } });
  };

  const handleDelete = (id: string) => {
    setDisabledDelete(id);
    setDisableAllDelete(true);
    const confirmToast = () =>
      toast.warn(
        <div>
          <div>Are you sure you want to delete this agent?</div>
          <div className="d-flex justify-content-end mt-2">
            <Button color="danger" onClick={() => confirmDelete(id)}>
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledDelete(null);
                setDisableAllDelete(false);
                toast.dismiss();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
          onClose: () => {
            setDisableAllDelete(false);
            setDisabledDelete(null);
          },
        }
      );

    const confirmDelete = async (id: string) => {
      setDisabledDelete(null);
      setDisableAllDelete(false);
      toast.dismiss();
      try {
        await axios.post(
          `${baseUrl}agent/delete`,
          { id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success(`Agent Deleted Successfully`, {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
          onClose: () => {
            setRefresh((prev) => prev + 1);
          },
        });
      } catch (error) {
        console.error("Error deleting agent:", error);
        toast.error("An error occurred while deleting the agent", {
          position: "top-right",
          autoClose: 1000,
          closeOnClick: true,
        });
      }
    };

    confirmToast();
  };

  const toggleEnable = (id: string, currentStatus: number) => {
    setDisabledEnable(id); // reuse this state if needed
    setDisableAllEnable(true);

    const confirmToggle = () => {
      toast.warn(
        <div>
          <div>
            Are you sure you want to{" "}
            <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
            agent?
          </div>
          <div className="d-flex justify-content-end mt-2">
            <Button
              color={currentStatus === 1 ? "danger" : "success"}
              onClick={() => confirmToggleEnable(id, currentStatus)}
            >
              Yes
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setDisabledEnable(null);
                setDisableAllEnable(false);
                toast.dismiss();
              }}
              className="ms-2"
            >
              Cancel
            </Button>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          draggable: false,
          onClose: () => {
            setDisabledEnable(null);
            setDisableAllEnable(false);
          },
        }
      );
    };

    const confirmToggleEnable = async (id: string, currentStatus: number) => {
      setDisabledEnable(null);
      setDisableAllEnable(false);
      toast.dismiss();

      try {
        const newStatus = currentStatus === 1 ? 0 : 1;

        await axios.post(
          `${baseUrl}agent/toggle_active`,
          { id, is_active: newStatus },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        toast.success(
          `Agent ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
          {
            position: "top-right",
            autoClose: 1000,
            closeOnClick: true,
            onClose: () => {
              setRefresh((prev) => prev + 1);
            },
          }
        );
      } catch (error) {
        console.error("Error toggling agent:", error);
        toast.error("Error updating enable status", {
          position: "top-right",
          autoClose: 1000,
        });
      }
    };

    confirmToggle();
  };

  const getStatusDetails = (status: number) => {
    switch (status) {
      case 1:
        return { text: "Online", color: "success" };
      case 0:
        return { text: "Offline", color: "danger" };
      case 2:
        return { text: "On Call", color: "warning" };
      default:
        return { text: "Unknown", color: "secondary" };
    }
  };
  const onSubmit = async (data: any) => {
    try {
      const file = data.document?.[0];
      if (!file) {
        toast.error("Please upload a document.");
        return;
      }

      const fileName = await uploadFile(file);

      const payload = {
        ...data,
        document: fileName,
        agent_id: selectedAgent.id,
        id: selectedAgent.call_payouts.id,
        transaction_id: data.transactionId,
        isrequest: 0,
        amount: selectedAgent.total_amount_without_currency,
        callstartdate: selectedAgent.call_duration_start_date,
        callenddate: selectedAgent.call_duration_end_date,
        is_paid: 1,
      };
      // console.log(payload)
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${baseUrl}call_payroll/update`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data?.message) {
        // ✅ Show toast for 2 seconds and call fetchData after toast closes
        toast.success(response.data.message, {
          autoClose: 1000,
          onClose: () => {
            fetchData(currentPage, perPage);
            reset();
            setShowPayoutModal(false);
            setSelectedAgent(null);
          },
        });
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "An error occurred while updating the payout.";
      toast.error(errorMessage);
    }
  };

  const formatPhoneNumber = (phone: string): string => {
    const digitsOnly = phone.replace(/\D/g, ""); // remove all non-digits

    if (digitsOnly.startsWith("91")) {
      return `+${digitsOnly.slice(0, 2)} ${digitsOnly.slice(2)}`;
    } else {
      return `+${digitsOnly.slice(0, 3)} ${digitsOnly.slice(3)}`;
    }
  };
  return (
    <>
      <Breadcrumbs
        pageTitle={ViewAgentTitle}
        parent={AgentTitle}
        title={ViewAgentTitle}
      />
      <Container fluid>
        <Row className="project-cards">
          <Col md={12} className="project-list">
            <Card>
              <Row className="align-items-center">
                <Col xs={12} md={6} className="mb-3 mb-md-0">
                  <Nav className="border-tab" tabs>
                    {projectListNavList.map((item) => (
                      <NavItem key={item.id}>
                        <NavLink
                          href={Href}
                          className={activeTab === item.id ? "active" : ""}
                          onClick={() => {
                            setActiveTab(item.id);
                            setCurrentPage(1);
                            const newStatus =
                              item.id === 1
                                ? null
                                : item.id === 2
                                  ? 1
                                  : item.id === 3
                                    ? 0
                                    : 2;
                            setStatus(newStatus);
                            fetchData(1, perPage, debouncedSearchTerm, newStatus);
                          }}
                        >
                          {item.icon}
                          {item.text}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                </Col>

                <Col xs={12} md={6} className="text-md-end text-start">
                  <FormGroup className="mb-0 d-flex flex-wrap justify-content-md-end justify-content-start gap-2">
                    <Btn
                      color="success"
                      onClick={handlehistory}
                      className="btn btn-success d-flex align-items-center justify-content-center"
                    >
                      <PhoneCall className="me-2" /> Call History
                    </Btn>
                    <Btn
                      onClick={handleVideoHistory}
                      className="btn btn-info d-flex align-items-center justify-content-center"
                    >
                      <Video className="me-2" /> Video Call History
                    </Btn>
                    <Btn
                      color="primary"
                      onClick={handleAdd}
                      className="btn btn-primary d-flex align-items-center justify-content-center"
                    >
                      <PlusSquare className="me-2" /> Add Agent
                    </Btn>
                  </FormGroup>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col sm={12}>
            <Card>
              <CardBody>
                <div className="mb-2">
                  <Row className="align-items-center justify-content-end">
                    <Col xl={3}>
                      <div className="mb-3 d-flex align-items-center">
                        <Input
                          type="text"
                          placeholder="Search"
                          value={filterText}
                          onChange={(e) => setFilterText(e.target.value)}
                          className="me-2"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <TabContent activeTab={activeTab}>
                  {loading ? (
                    <div className="d-flex justify-content-center p-5">
                      <Spinner color="primary" />
                    </div>
                  ) : getFilteredAgents().length > 0 ? (
                    <TabPane tabId={activeTab}>
                      <Row>
                        {getFilteredAgents().map((item: any, index) => {
                          const { text: badgeText, color: badgeColor } =
                            getStatusDetails(item.is_online);
                          return (
                            <Col xxl={4} md={6} key={index}>
                              <div
                                className={`project-box font-dark bg-light-${badgeColor}`}
                              >
                                <Badges color={badgeColor}>{badgeText}</Badges>
                                <H5
                                  className={`f-w-500 mb-2 text-${badgeColor}`}
                                >
                                  {item.agent_name}
                                  {item.is_terms_and_conditions == 1 && (
                                    <i
                                      className="fa fa-check-circle text-primary ms-2"
                                      title="Verified Agent"
                                      style={{ fontSize: "16px" }}
                                    />
                                  )}
                                </H5>
                                <div className="d-flex mb-2 align-items-center justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <Image
                                      className="img-30 me-2 rounded-circle"
                                      src={`${mediaUrl}/${item.image}`}
                                      alt="agent"
                                    />
                                    <P className="font-light mb-0">
                                      {item.email}
                                    </P>
                                  </div>

                                  {item.call_payouts?.isrequest === 1 && (
                                    <Button
                                      color="success"
                                      size="sm"
                                      onClick={() => {
                                        setSelectedAgent(item);
                                        setShowPayoutModal(true);
                                      }}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      title="Pay Now"
                                    >
                                      Pay Now
                                    </Button>
                                  )}
                                </div>
                                <P className="mb-2">{item.address}</P>
                                <Row
                                  className="details"
                                // style={{ height: "150px" }}
                                >
                                  <Col xs={4}>
                                    <span>Phone</span>
                                  </Col>
                                  <Col xs={8} className={`font-${badgeColor}`}>
                                    {formatPhoneNumber(item.phone)}
                                  </Col>

                                  <Col xs={4}>
                                    <span>Languages</span>
                                  </Col>
                                  <Col xs={8}>
                                    <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                                      {item.languages?.map(
                                        (lang: any, idx: number) => (
                                          <Image
                                            key={idx}
                                            className="img-20 rounded-circle"
                                            src={`${mediaUrl}/${lang.icon}`}
                                            alt={lang.language}
                                            title={lang.language}
                                          />
                                        )
                                      )}
                                    </div>
                                    {item.languages
                                      ?.map((lang: any) => lang.language)
                                      .join(", ")}
                                  </Col>

                                  <Col xs={4}>
                                    <span>Brands</span>
                                  </Col>
                                  <Col xs={8}>
                                    <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                                      {item.brands?.map(
                                        (brand: any, idx: number) => (
                                          <Image
                                            key={idx}
                                            className="img-20 rounded-circle"
                                            src={`${mediaUrl}/${brand.logo}`}
                                            alt={brand.brand_name}
                                            title={brand.brand_name}
                                          />
                                        )
                                      )}
                                    </div>
                                    {item.brands
                                      ?.map((brand: any) => brand.brand_name)
                                      .join(", ")}
                                  </Col>

                                  <Col xs={4}>
                                    <strong className="d-block">
                                      {" "}
                                      Call Duration
                                    </strong>
                                  </Col>
                                  <Col xs={8}>
                                    <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                                      {item.total_call_duration}
                                    </div>
                                  </Col>
                                </Row>
                                <Col xs={12} className="mt-2">
                                  <div className="d-flex flex-wrap justify-content-between gap-3">
                                    <div className="d-flex align-items-center">
                                      <i className="fa fa-dollar-sign text-success me-2 fs-5" />
                                      <div>
                                        <strong className="d-block">
                                          Revenue Generated
                                        </strong>
                                        <strong className="d-block">
                                          by Agent
                                        </strong>
                                        <span className="text-muted">
                                          {item.total_customer_amount}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <i className="fa fa-wallet text-warning me-2 fs-5" />
                                      <div>
                                        <strong className="d-block">
                                          Agent's Pending
                                        </strong>
                                        <strong className="d-block">
                                          Payout
                                        </strong>
                                        <span className="text-muted">
                                          {item.total_amount}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </Col>

                                <Col
                                  xs={12}
                                  className="mt-2"
                                  style={{ zIndex: 2 }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    {/* Left: Buttons */}
                                    <div className="d-flex">
                                      <Button
                                        color={
                                          item.is_active
                                            ? "success"
                                            : "secondary"
                                        }
                                        size="sm"
                                        onClick={() =>
                                          toggleEnable(item.id, item.is_active)
                                        }
                                        disabled={
                                          disabledEnable === item.id ||
                                          disableAllEnable
                                        }
                                        style={{
                                          marginRight: "5px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        title={
                                          item.is_active ? "Disable" : "Enable"
                                        }
                                      >
                                        <i
                                          className={`fa ${item.is_active
                                              ? "fa-check-circle"
                                              : "fa-ban"
                                            }`}
                                        />
                                      </Button>

                                      <Button
                                        color="primary"
                                        size="sm"
                                        onClick={() => handleEdit(item.id)}
                                        style={{
                                          marginRight: "5px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        title="Edit"
                                      >
                                        <i className="icon-pencil-alt" />
                                      </Button>

                                      <Button
                                        color="danger"
                                        size="sm"
                                        onClick={() => handleDelete(item.id)}
                                        disabled={
                                          disabledDelete === item.id ||
                                          disableAllDelete
                                        }
                                        style={{
                                          marginRight: "5px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        title="Delete"
                                      >
                                        <i className="icon-trash" />
                                      </Button>

                                      <Button
                                        color="info"
                                        size="sm"
                                        onClick={() =>
                                          handleagenthistory(item.id)
                                        }
                                        style={{
                                          marginRight: "5px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        title="Call History"
                                      >
                                        <i className="fa fa-phone" />
                                      </Button>
                                      <Button
                                        color="warning"
                                        size="sm"
                                        style={{
                                          marginRight: "5px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        title="Payout"
                                        onClick={() => {
                                          navigate("/payout_report", {
                                            state: {
                                              agentId: item.id,
                                            },
                                          });
                                        }}
                                      >
                                        <i className="fa fa-money-bill-wave" />
                                      </Button>
                                      <Button
                                        color="teal"
                                        size="sm"
                                        onClick={() =>
                                          handleVideoCallHistory(item.id)
                                        }
                                        style={{
                                          marginRight: "5px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          backgroundColor: "#20c997", // custom teal
                                          borderColor: "#20c997",
                                        }}
                                        title="Video Call History"
                                      >
                                        <Video size={14} />
                                      </Button>
                                    </div>

                                    {/* Right: Rating */}
                                    <div
                                      className="text-end"
                                      style={{
                                        minWidth: "120px",
                                        fontSize: "0.85rem",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      <div
                                        title={`Average Rating: ${item.average_rating}`}
                                      >
                                        <StarRatings
                                          rating={item.average_rating}
                                          starRatedColor="#ffd700"
                                          numberOfStars={5}
                                          starDimension="18px"
                                          starSpacing="1px"
                                        />
                                      </div>
                                      ({item.rating_count} Review)
                                    </div>
                                  </div>
                                </Col>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                      <Row className="justify-content-end mt-3">
                        <Col xl="auto">
                          <div className="d-flex gap-2 flex-wrap">
                            {/* Previous Button */}
                            <Button
                              color="primary"
                              disabled={currentPage === 1}
                              onClick={() => handlePageChange(currentPage - 1)}
                            >
                              <FaArrowLeft size={18} />
                            </Button>

                            {/* Page Numbers */}
                            {Array.from(
                              { length: totalPages },
                              (_, i) => i + 1
                            ).map((page) => (
                              <Button
                                key={page}
                                color={
                                  page === currentPage ? "success" : "secondary"
                                }
                                onClick={() => handlePageChange(page)}
                              >
                                {page}
                              </Button>
                            ))}

                            {/* Next Button */}
                            <Button
                              color="primary"
                              disabled={currentPage === totalPages}
                              onClick={() => handlePageChange(currentPage + 1)}
                            >
                              <FaArrowRight size={18} />
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  ) : (
                    <TabPane tabId={activeTab}>
                      <div className="text-center mt-5">
                        <h5>No agents available</h5>
                      </div>
                    </TabPane>
                  )}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {showPayoutModal && selectedAgent && (
          <Modal
            isOpen={showPayoutModal}
            toggle={() => setShowPayoutModal(false)}
          >
            <ModalHeader toggle={() => setShowPayoutModal(false)}>
              Agent Payout - {selectedAgent.agent_name}
            </ModalHeader>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <ModalBody>
                <Row className="g-3">
                  <Col xs={12}>
                    <strong>Payment Duration:</strong>
                    <br />
                    {selectedAgent.call_duration_start_date} to{" "}
                    {selectedAgent.call_duration_end_date}
                  </Col>
                  <Col xs={12}>
                    <strong>Total Call Duration:</strong>
                    <br />
                    {selectedAgent.total_call_duration}
                  </Col>
                  <Col xs={12}>
                    <strong>Total Amount:</strong>
                    <br />
                    {selectedAgent.total_amount}
                  </Col>
                  <Col xs={12}>
                    <Label htmlFor="transactionId">Transaction ID</Label>
                    <Controller
                      name="transactionId"
                      control={control}
                      rules={{ required: "Transaction ID is required" }}
                      render={({ field }) => (
                        <Input
                          type="text"
                          {...field}
                          placeholder="Enter Transaction ID"
                        />
                      )}
                    />
                    {errors.transactionId &&
                      typeof errors.transactionId.message === "string" && (
                        <span className="text-danger">
                          {errors.transactionId.message}
                        </span>
                      )}
                  </Col>
                  <Col xs={12}>
                    <Label htmlFor="proof">Upload Payment Proof</Label>
                    <Controller
                      name="document"
                      control={control}
                      rules={{
                        required: "Payment proof is required",
                        validate: {
                          isImage: (value) => {
                            if (!value || !value[0]) return "File is required";
                            const acceptedTypes = [
                              "image/jpeg",
                              "image/png",
                              "image/gif",
                              "image/webp",
                              "image/svg+xml",
                            ];
                            return acceptedTypes.includes(value[0].type)
                              ? true
                              : "Only image files are allowed (JPEG, PNG, GIF, WEBP, SVG)";
                          },
                          maxSize: (value) => {
                            if (!value || !value[0]) return true;
                            return value[0].size <= 5 * 1024 * 1024 // 5MB
                              ? true
                              : "File size must be less than 5MB";
                          },
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <div>
                          <Input
                            type="file"
                            onChange={(e) => field.onChange(e.target.files)}
                            accept="image/*"
                          />
                          {error && (
                            <span className="text-danger">{error.message}</span>
                          )}
                        </div>
                      )}
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" type="submit">
                  Submit Payout
                </Button>
                <Button
                  color="secondary"
                  onClick={() => {
                    setShowPayoutModal(false);
                    reset();
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
        )}
      </Container>
      <ToastContainer />
    </>
  );
}

// //////////without pagination
// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Card,
//   CardBody,
//   Col,
//   Container,
//   FormGroup,
//   Nav,
//   NavItem,
//   NavLink,
//   Row,
//   Spinner,
//   TabContent,
//   TabPane,
// } from "reactstrap";
// import { Link } from "react-router-dom";
// import { PlusSquare, Wifi, WifiOff, Target, PhoneCall } from "react-feather"; // added PhoneCall
// import axios from "axios";
// import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
// import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
// import { ViewAgentTitle, AgentTitle, Href } from "../../../Utils/Constants";
// import { Badges, H5, P, UL, LI, Image, Btn } from "../../../AbstractElements";
// import { baseUrl, mediaUrl } from "../../../Utils/FileUpload";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// // ✅ Updated with "On Call" status tab
// const projectListNavList = [
//   { id: 1, icon: <Target />, text: "All" },
//   { id: 2, icon: <Wifi />, text: "Online" },
//   { id: 3, icon: <WifiOff />, text: "Offline" },
//   { id: 4, icon: <PhoneCall />, text: "On Call" }, // new tab
// ];
// interface Agent {
//   id: string;
//   agent_name: string;
//   email: string;
//   address: string;
//   phone: string;
//   image: string;
//   is_online: number;
//   is_active: number;
//   languages?: { language: string; icon: string }[];
//   brands?: { brand_name: string; logo: string }[];
//   is_deleted: number;
// }

// export default function ViewAgent() {
//   const [activeTab, setActiveTab] = useState(1);
//   const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
//   const [disableAllDelete, setDisableAllDelete] = useState(false);
//   const [filteredItems, setFilteredItems] = useState<Agent[]>([]);
//   const [refresh, setRefresh] = useState<number>(0);
//   const [loading, setLoading] = useState(false);
//   const [disabledEnable, setDisabledEnable] = useState<string | null>(null);
//   const [disableAllEnable, setDisableAllEnable] = useState(false);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");
//   const [filterText, setFilterText] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`${baseUrl}agent/getall`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         const data: Agent[] = response.data;
//         // setFilteredItems(
//         //   data
//         //     .filter((brand) => brand.is_deleted === 0)
//         //     .sort((a, b) => b.is_active - a.is_active)
//         // );
//         setFilteredItems(data);
//         // console.log(data)
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [refresh]);

//   const handleAdd = () => {
//     navigate("/add_agent");
//   };

//   const handlehistory = () => {
//     navigate("/call_history");
//   };

//   // ✅ Updated filter logic
//   const getFilteredAgents = () => {
//     let agents = filteredItems;

//     // Apply tab filter
//     switch (activeTab) {
//       case 2:
//         agents = agents.filter((item: any) => item.is_online === 1);
//         break;
//       case 3:
//         agents = agents.filter((item: any) => item.is_online === 0);
//         break;
//       case 4:
//         agents = agents.filter((item: any) => item.is_online === 2);
//         break;
//       default:
//         break;
//     }

//     // Apply search filter
//     if (filterText.trim() !== "") {
//       const lowerSearch = filterText.toLowerCase();

//       agents = agents.filter((item: Agent) => {
//         const matchAgentName = item.agent_name?.toLowerCase().includes(lowerSearch);
//         const matchEmail = item.email?.toLowerCase().includes(lowerSearch);
//         const matchPhone = item.phone?.toLowerCase().includes(lowerSearch);
//         const matchAddress = item.address?.toLowerCase().includes(lowerSearch);

//         const matchLanguages = item.languages?.some((lang: any) =>
//           lang.language.toLowerCase().includes(lowerSearch)
//         );

//         const matchBrands = item.brands?.some((brand: any) =>
//           brand.brand_name.toLowerCase().includes(lowerSearch)
//         );

//         return (
//           matchAgentName ||
//           matchEmail ||
//           matchPhone ||
//           matchAddress ||
//           matchLanguages ||
//           matchBrands
//         );
//       });
//     }

//     return agents;
//   };

//   if (loading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   const handleEdit = (id: string) => {
//     navigate("/edit_agent", { state: { id: id } });
//   };

//   const handleagenthistory = (id: string) => {
//     navigate("/call_history", { state: { agent_id: id } });
//   };

//   const handleDelete = (id: string) => {
//     setDisabledDelete(id);
//     setDisableAllDelete(true);
//     const confirmToast = () =>
//       toast.warn(
//         <div>
//           <div>Are you sure you want to delete this agent?</div>
//           <div className="d-flex justify-content-end mt-2">
//             <Button color="danger" onClick={() => confirmDelete(id)}>
//               Yes
//             </Button>
//             <Button
//               color="secondary"
//               onClick={() => {
//                 setDisabledDelete(null);
//                 setDisableAllDelete(false);
//                 toast.dismiss();
//               }}
//               className="ms-2"
//             >
//               Cancel
//             </Button>
//           </div>
//         </div>,
//         {
//           position: "top-right",
//           autoClose: false,
//           closeOnClick: false,
//           closeButton: false,
//           draggable: false,
//           onClose: () => {
//             setDisableAllDelete(false);
//             setDisabledDelete(null);
//           },
//         }
//       );

//     const confirmDelete = async (id: string) => {
//       setDisabledDelete(null);
//       setDisableAllDelete(false);
//       toast.dismiss();
//       try {
//         await axios.post(
//           `${baseUrl}agent/delete`,
//           { id },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         toast.success(`Agent Deleted Successfully`, {
//           position: "top-right",
//           autoClose: 1000,
//           closeOnClick: true,
//         });
//         setFilteredItems((prevItems) =>
//           prevItems.filter((item) => item.id !== id)
//         );
//       } catch (error) {
//         console.error("Error deleting agent:", error);
//         toast.error("An error occurred while deleting the agent", {
//           position: "top-right",
//           autoClose: 1000,
//           closeOnClick: true,
//         });
//       }
//     };

//     confirmToast();
//   };

//   const toggleEnable = (id: string, currentStatus: number) => {
//     setDisabledEnable(id); // reuse this state if needed
//     setDisableAllEnable(true);

//     const confirmToggle = () => {
//       toast.warn(
//         <div>
//           <div>
//             Are you sure you want to{" "}
//             <strong>{currentStatus === 1 ? "disable" : "enable"}</strong> this
//             agent?
//           </div>
//           <div className="d-flex justify-content-end mt-2">
//             <Button
//               color={currentStatus === 1 ? "danger" : "success"}
//               onClick={() => confirmToggleEnable(id, currentStatus)}
//             >
//               Yes
//             </Button>
//             <Button
//               color="secondary"
//               onClick={() => {
//                 setDisabledEnable(null);
//                 setDisableAllEnable(false);
//                 toast.dismiss();
//               }}
//               className="ms-2"
//             >
//               Cancel
//             </Button>
//           </div>
//         </div>,
//         {
//           position: "top-right",
//           autoClose: false,
//           closeOnClick: false,
//           closeButton: false,
//           draggable: false,
//           onClose: () => {
//             setDisabledEnable(null);
//             setDisableAllEnable(false);
//           },
//         }
//       );
//     };

//     const confirmToggleEnable = async (id: string, currentStatus: number) => {
//       setDisabledEnable(null);
//       setDisableAllEnable(false);
//       toast.dismiss();

//       try {
//         const newStatus = currentStatus === 1 ? 0 : 1;

//         await axios.post(
//           `${baseUrl}agent/toggle_active`,
//           { id, is_active: newStatus },
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         toast.success(
//           `Agent ${newStatus === 1 ? "enabled" : "disabled"} successfully!`,
//           {
//             position: "top-right",
//             autoClose: 1000,
//             closeOnClick: true,
//             onClose: () => {
//               setRefresh((prev) => prev + 1);
//             },
//           }
//         );
//       } catch (error) {
//         console.error("Error toggling agent:", error);
//         toast.error("Error updating enable status", {
//           position: "top-right",
//           autoClose: 1000,
//         });
//       }
//     };

//     confirmToggle();
//   };

//   const getStatusDetails = (status: number) => {
//     switch (status) {
//       case 1:
//         return { text: "Online", color: "success" };
//       case 0:
//         return { text: "Offline", color: "danger" };
//       case 2:
//         return { text: "On Call", color: "warning" };
//       default:
//         return { text: "Unknown", color: "secondary" };
//     }
//   };

//   return (
//     <>
//       <Breadcrumbs
//         pageTitle={ViewAgentTitle}
//         parent={AgentTitle}
//         title={ViewAgentTitle}
//       />
//       <Container fluid>
//         <Row className="project-cards">
//           <Col md={12} className="project-list">
//             <Card>
//               <Row>
//                 <Col md={6}>
//                   <Nav className="border-tab" tabs>
//                     {projectListNavList.map((item) => (
//                       <NavItem key={item.id}>
//                         <NavLink
//                           href={Href}
//                           className={activeTab === item.id ? "active" : ""}
//                           onClick={() => setActiveTab(item.id)}
//                         >
//                           {item.icon} {item.text}
//                         </NavLink>
//                       </NavItem>
//                     ))}
//                   </Nav>
//                 </Col>
//                 <Col md={6} className="d-md-block d-none text-end">
//                   <FormGroup className="mb-0">
//                     <Btn
//                       color="success"
//                       onClick={handlehistory}
//                       className="btn btn-primary d-flex align-items-center justify-content-center"
//                     >
//                       <PhoneCall className="me-2" /> Call History
//                     </Btn>
//                     <Btn
//                       color="primary"
//                       onClick={handleAdd}
//                       className="btn btn-primary d-flex align-items-center justify-content-center"
//                     >
//                       <PlusSquare className="me-2" /> Add Agent
//                     </Btn>
//                   </FormGroup>
//                 </Col>
//               </Row>
//             </Card>
//           </Col>

//           <Col sm={12}>
//             <Card>
//               <CardBody>
//                 <div className="mb-2">
//                 <FilterComponent
//                   onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
//                     setFilterText(e.target.value)
//                   }
//                   filterText={filterText}
//                 />
//                 </div>
//                 <TabContent activeTab={activeTab}>
//                   <TabPane tabId={activeTab}>
//                     <Row>
//                       {getFilteredAgents().map((item: any, index) => {
//                         const { text: badgeText, color: badgeColor } =
//                           getStatusDetails(item.is_online);
//                         return (
//                           <Col xxl={4} md={6} key={index}>
//                             <div
//                               className={`project-box font-dark bg-light-${badgeColor}`}
//                             >
//                               <Badges color={badgeColor}>{badgeText}</Badges>
//                               <H5 className={`f-w-500 mb-2 text-${badgeColor}`}>
//                                 {item.agent_name}
//                               </H5>
//                               <div className="d-flex mb-2 align-items-center">
//                                 <Image
//                                   className="img-30 me-2 rounded-circle"
//                                   src={`${mediaUrl}/${item.image}`}
//                                   alt="agent"
//                                 />
//                                 <P className="font-light mb-0">{item.email}</P>
//                               </div>
//                               <P className="mb-2">{item.address}</P>
//                               <Row
//                                 className="details"
//                                 style={{ height: "150px" }}
//                               >
//                                 <Col xs={4}>
//                                   <span>Phone</span>
//                                 </Col>
//                                 <Col xs={8} className={`font-${badgeColor}`}>
//                                   {item.phone}
//                                 </Col>

//                                 <Col xs={4}>
//                                   <span>Languages</span>
//                                 </Col>
//                                 <Col xs={8}>
//                                   <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
//                                     {item.languages?.map(
//                                       (lang: any, idx: number) => (
//                                         <Image
//                                           key={idx}
//                                           className="img-20 rounded-circle"
//                                           src={`${mediaUrl}/${lang.icon}`}
//                                           alt={lang.language}
//                                           title={lang.language}
//                                         />
//                                       )
//                                     )}
//                                   </div>
//                                   {item.languages
//                                     ?.map((lang: any) => lang.language)
//                                     .join(", ")}
//                                 </Col>

//                                 <Col xs={4}>
//                                   <span>Brands</span>
//                                 </Col>
//                                 <Col xs={8}>
//                                   <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
//                                     {item.brands?.map(
//                                       (brand: any, idx: number) => (
//                                         <Image
//                                           key={idx}
//                                           className="img-20 rounded-circle"
//                                           src={`${mediaUrl}/${brand.logo}`}
//                                           alt={brand.brand_name}
//                                           title={brand.brand_name}
//                                         />
//                                       )
//                                     )}
//                                   </div>
//                                   {item.brands
//                                     ?.map((brand: any) => brand.brand_name)
//                                     .join(", ")}
//                                 </Col>
//                               </Row>
//                               <Col xs={12} className="mt-2">
//                                 <label className="w-100">Rating</label>
//                                 {[...Array(5)].map((_, i) => (
//                                   <i
//                                     key={i}
//                                     className="fa fa-star text-warning me-1"
//                                   />
//                                 ))}
//                               </Col>

//                               <Col
//                                 xs={12}
//                                 className="mt-2"
//                                 style={{ zIndex: 2 }}
//                               >
//                                 <div className="d-flex justify-content">
//                                   <Button
//                                     color={
//                                       item.is_active ? "success" : "secondary"
//                                     }
//                                     size="sm"
//                                     onClick={() =>
//                                       toggleEnable(item.id, item.is_active)
//                                     }
//                                     disabled={
//                                       disabledEnable === item.id ||
//                                       disableAllEnable
//                                     }
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                     title={
//                                       item.is_active ? "Disable" : "Enable"
//                                     }
//                                   >
//                                     <i
//                                       className={`fa ${
//                                         item.is_active
//                                           ? "fa-check-circle"
//                                           : "fa-ban"
//                                       }`}
//                                     />
//                                   </Button>

//                                   <Button
//                                     color="primary"
//                                     size="sm"
//                                     onClick={() => handleEdit(item.id)}
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                   >
//                                     <i className="icon-pencil-alt " />
//                                   </Button>
//                                   <Button
//                                     color="danger"
//                                     size="sm"
//                                     onClick={() => handleDelete(item.id)}
//                                     disabled={
//                                       disabledDelete === item.id ||
//                                       disableAllDelete
//                                     }
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                   >
//                                     <i className="icon-trash" />
//                                   </Button>
//                                   <Button
//                                     color="info"
//                                     size="sm"
//                                     onClick={() => handleagenthistory(item.id)}
//                                     style={{
//                                       marginRight: "5px",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "center",
//                                     }}
//                                     title="View Call History"
//                                   >
//                                     <i className="fa fa-phone" />
//                                   </Button>
//                                 </div>
//                               </Col>
//                             </div>
//                           </Col>
//                         );
//                       })}
//                     </Row>
//                   </TabPane>
//                 </TabContent>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//       <ToastContainer />
//     </>
//   );
// }
